import React from "react";
import { useLang } from "@/context/LanguageContext";
import { IMAGE_NOTE } from "@/i18n/content";

// Small disclaimer shown under product imagery: photos are illustrative / non-official.
export const ImageNote = ({ className = "" }) => {
  const { t } = useLang();
  return (
    <p data-testid="image-note" className={`text-[10px] uppercase tracking-widest text-white/35 ${className}`}>
      {t(IMAGE_NOTE)}
    </p>
  );
};
